import { createCurrentWallet as coreCreateCurrentWallet } from '@web3-wallet/core';
import { createReactWallet } from './createReactWallet';
import { useMutation } from './query';
export const createCurrentWallet = (connectorsOrWallets, options) => {
    const coreCurrentWallet = coreCreateCurrentWallet(connectorsOrWallets, options);
    const currentReactWallet = createReactWallet(coreCurrentWallet);
    const useName = () => currentReactWallet.getReactStore()((s) => s.name);
    const useConnectionStatus = () => currentReactWallet.getReactStore()((s) => s.connectionStatus);
    return {
        ...currentReactWallet,
        useName,
        useConnectionStatus,
        useConnectAsCurrentWallet: (options) => useMutation((variables) => currentReactWallet.connectAsCurrentWallet(variables.walletName, variables.chain), options),
    };
};
